import { useMutation, useQueryClient } from '@tanstack/react-query';
import { goodsService } from 'shared/src/api/goodsService';
import { bridge } from 'shared/src/utils';
import { queryKey } from '../constant/queryKey';
import { useGoodsSno } from '../hooks/useGoodsSno';

export const usePostParticipateLiveCampaign = () => {
  const client = useQueryClient();
  const goodsSno = useGoodsSno();

  return useMutation({
    throwOnError: false,
    mutationFn: (eventSno: number) =>
      goodsService.postParticipateLiveCampaign(eventSno),
    onSuccess: message => {
      bridge.toast(message);
      client.invalidateQueries({
        queryKey: queryKey.relatedLiveCampaign(goodsSno),
      });
    },
  });
};
